import { useQuery } from "@tanstack/react-query";
import { getBookingsDataDetail } from "..";

const useBookingsDataDetail = (id: string) => {
    return useQuery({
        queryKey: ["bookingsDetail-data", id],
        queryFn: () => getBookingsDataDetail(id),
    });
};

export default useBookingsDataDetail;
